import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { Validator } from '../../../shared/services/validator';
import { CTRL_NAME_EXTRACTOR } from '../ctrl.name.extractor';

export class CTRL_322 implements Validator {

    public static id = 'CTRL_322';
    private message = 'error.ctr_322';


    public LOG: LogService = new LogService(CTRL_322);
    public formExtractorService: FormExtractorService = new FormExtractorService();

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_322.id + '_');

        if (rgs.length > 0) {
            for (let rg of rgs) {
                const ctrl = form.controls[rg];
                const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);
                const lotMarcheIters = this.formExtractorService.getIndexes(Array.from(controls.keys()), ['_SepSep_LotMarche'], '_SepSep_Attribution_index_');
                
                if (lotMarcheIters.size > 0) {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                } else {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                }
            }
        }
    }
}
